import React, { useEffect, useState } from "react";
import Meta from "../../components/Meta";
import { useAccount } from "wagmi";
import { Typography } from "@material-tailwind/react";
import { Paper, Snackbar } from "@mui/material";
import ImageTitle from "../../components/imageTitle";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { useRouter } from "next/router";
import BorrowTab from "../../components/tabs/BorrowTab";
import LendTab from "../../components/tabs/LendTab";
import ShareDropdown from "../../components/shareDropdown";

const Account = () => {
  const { address, isConnected } = useAccount();
  const router = useRouter();

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const [itemActive, setItemActive] = useState(1);

  const tabItem = [
    {
      id: 1,
      text: "Borrow",
      icon: "Lend",
    },
    {
      id: 2,
      text: "Lend",
      icon: "owned",
    },
  ];

  useEffect(() => {
    if (!router.isReady) return;
    const { active } = router.query;
    if (active && typeof active === "string") {
      setItemActive(parseInt(active));
    }
  }, [router.isReady, router.query]);

  const handleSelect = (index: number) => {
    const active = index + 1;
    setItemActive(active);
    router.replace(
      {
        pathname: router.pathname,
        query: { active },
      },
      undefined,
      { shallow: true }
    );
  };

  return (
    <div className="mt-28">
      <Meta title="Bit5 Lending | Account" />
      {isConnected ? (
        <div>
          <ImageTitle
            text="Account"
            image={"/images/lending-account.png"}
            input={undefined}
          />
          <section className="relative py-24">
            <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden">
              <img
                src="/images/gradient_light.jpg"
                alt="gradient"
                className="h-full w-full"
              />
            </picture>
            <div className="container">
              {/* <!-- Tabs Nav --> */}
              <Tabs
                selectedIndex={itemActive - 1}
                onSelect={handleSelect}
                className="tabs"
              >
                <TabList className="nav nav-tabs scrollbar-custom mb-2 flex items-center justify-start overflow-x-auto overflow-y-hidden border-b border-jacarta-100 pb-px dark:border-jacarta-600 md:justify-center">
                  {tabItem.map(({ id, text, icon }) => {
                    return (
                      <Tab className="nav-item" role="presentation" key={id}>
                        <button
                          className={
                            itemActive === id
                              ? "nav-link hover:text-jacarta-700 text-jacarta-400 relative flex items-center whitespace-nowrap py-3 px-6 dark:hover:text-white active"
                              : "nav-link hover:text-jacarta-700 text-jacarta-400 relative flex items-center whitespace-nowrap py-3 px-6 dark:hover:text-white"
                          }
                        >
                          <span className="font-display text-base font-medium">
                            {text}
                          </span>
                        </button>
                      </Tab>
                    );
                  })}
                </TabList>
                <div className="flex justify-end">
                  <ShareDropdown />
                </div>

                <TabPanel>
                  <BorrowTab />
                </TabPanel>
                <TabPanel>
                  <LendTab />
                </TabPanel>
              </Tabs>
            </div>
          </section>
          {/* <!-- end create --> */}
          <Snackbar
            open={snackbarOpen}
            autoHideDuration={6000}
            onClose={() => {
              setSnackbarOpen(false);
              setSnackbarMessage("");
            }}
            message={snackbarMessage}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            sx={{
              ".MuiPaper-root, .MuiPaper-root *": {
                backgroundColor: "white !important",
                color: "black !important",
              },
            }}
          />
        </div>
      ) : (
        <div
          style={{
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Paper
            style={{}}
            className="dark:bg-jacarta-700 p-5 dark:border-jacarta-600 border-jacarta-100 !rounded-2lg border bg-white flex items-center justify-center text-center py-5"
          >
            <Typography variant="h4" className="text-center dark:text-white">
              Please Connect Your Wallet
            </Typography>
          </Paper>
        </div>
      )}
    </div>
  );
};

export default Account;
